/**
 *
 * Question
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
//import Swal from 'sweetalert2';

//import SharedHeader from '@/components/SharedHeader.vue';
import Footer from '@/components/Footer.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import Aside from '@/components/Aside.vue';
//import TabBar from '@/components/TabBar.vue';
import Spinner from '@/components/Spinner.vue';
import PzButton from '@/components/PzButton.vue';
import QaAnswerModal from '@/views/QA/Question/components/QaAnswerModal.vue';
import GradeModal from '@/views/QA/Question/components/GradeModal.vue';
import SetUnreadBtn from '@/views/QA/Question/components/SetUnreadBtn.vue';
import OpenQuestionBtn from '@/views/QA/Question/components/OpenQuestionBtn.vue';
import ImgModal from '@/views/QA/Question/components/ImgModal.vue';
import FollowBtn from '@/views/QA/Question/components/FollowBtn.vue';
import QaQuestionContentQuestion from '@/views/QA/Question/components/QaQuestionContentQuestion.vue';
import QaQuestionContentTeacherAnswer from '@/views/QA/Question/components/QaQuestionContentTeacherAnswer.vue';
import QaQuestionContentAnswer from '@/views/QA/Question/components/QaQuestionContentAnswer.vue';
import QuestionReferralList from '@/views/QA/Question/components/QuestionReferralList.vue';

import { QuestionMixin } from '@/mixins/Question';
import { ClassRestrictionMixin } from '@/mixins/ClassRestriction';
import { TimetagInHtmlMixin } from '@/mixins/MtEditor/TimetagInHtmlMixin';

import { QA_QUESTION_LIST_PAGE } from '@/constants/routes';
import { LOADING_MESSAGE } from './Question.constants';

const GetQaQuestionMixin = {
  name: 'GetQaQuestionMixin',

  data: () => {
    return {
      promiseGetQaQuestion: null,
    };
  },

  methods: {
    ...mapActions('QA/Question', {
      ma_getQaQuestion: 'getQaQuestion',
    }),

    getQaQuestion() {
      this.promiseGetQaQuestion = this.ma_getQaQuestion(this.$route.params.id);
    },
  },

  created() {
    this.getQaQuestion();
    this.$bus.once('login-modal-closed', this.getQaQuestion);
  },

  beforeDestroy() {
    this.$bus.off('login-modal-closed', this.getQaQuestion);
  },
};

// GetQaQuestionMixin
const QuestionCommentCountdownMixin = {
  name: 'QuestionCommentCountdownMixin',

  data: () => {
    return {
      intervalUpdateCommentCountdown: null,
    };
  },

  methods: {
    ...mapActions('QA/Question', {
      ma_updateCommentCountdown: 'updateCommentCountdown',
    }),

    async QuestionCommentMixinCreated() {
      await this.promiseGetQaQuestion;
      this.intervalUpdateCommentCountdown = setInterval(this.ma_updateCommentCountdown, 1000);
    },

    QuestionCommentMixinBeforeDestroy() {
      clearInterval(this.intervalUpdateCommentCountdown);
    },
  },

  created() {
    this.QuestionCommentMixinCreated();
  },

  beforeDestroy() {
    this.QuestionCommentMixinBeforeDestroy();
  },
};

const BusStateMixin = {
  name: 'BusStateMixin',

  data: () => {
    return {
      busState: '',
    };
  },
};

// GetQaQuestionMixin, BusStateMixin
const QaAnswerMixin = {
  name: 'QaAnswerMixin',

  components: {
    QaAnswerModal,
  },

  data: () => {
    return {
      isCurrentStudentAnswered: false,
    };
  },

  methods: {
    //gotoWriteAnswer() {
    //  this.$refs.writeAnswer.scrollIntoView();
    //},

    async showQaAnswerModal() {
      this.busState = '';
      await this.$nextTick();
      await this.promiseGetQaQuestion;
      this.$refs.QaAnswerModal.openQA();
    },

    handleQaAnswerPosted() {
      this.isCurrentStudentAnswered = true;
    },
  },
};

export const GradeMixin = {
  name: 'GradeMixin',

  components: {
    GradeModal,
  },

  data: () => {
    return {
      isPostQaGradeDone: false,

      toRouteFullPath: '',
    };
  },

  computed: {
    ...mapState('QA/Question', {
      ms_qaQuestion: 'qaQuestion',
    }),

    c_isStopRouter() {
      return this.ms_qaQuestion.needGrade && !this.isPostQaGradeDone;
    },
  },

  methods: {
    handlePostQaGradeDone() {
      this.isPostQaGradeDone = true;
      this.$refs.GradeModal.hide();
    },

    handleQaGradeModalHidden() {
      this.$router.push(this.toRouteFullPath);
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.c_isStopRouter) {
      this.toRouteFullPath = to.fullPath;
      this.$refs.GradeModal.show();
      next(false);
    } else {
      next();
    }
  },
};

const SetUnreadMixin = {
  name: 'SetUnreadMixin',

  components: {
    SetUnreadBtn,
  },

  computed: {
    ...mapState('QA/Question', {
      ms_qaQuestion: 'qaQuestion',
    }),

    c_isShowSetUnreadBtn() {
      return (
        this.ms_qaQuestion.isMyQuestion ||
        this.ms_qaQuestion.isAnswered ||
        this.ms_qaQuestion.isFollowed
      );
    },
  },
};

// QuestionMixin
const OpenQuestionMixin = {
  name: 'OpenQuestionMixin',

  components: {
    OpenQuestionBtn,
  },

  computed: {
    ...mapState('QA/Question', {
      ms_qaQuestion: 'qaQuestion',
    }),

    c_isHaveExercise() {
      return (
        this.ms_qaQuestion.isMyQuestion &&
        this.ms_qaQuestion.courseId &&
        this.ms_qaQuestion.questionId
      );
    },
  },

  methods: {
    handleOpenQuestion() {
      this.openQuestion(this.ms_qaQuestion);
    },
  },
};

const ImgModalMixin = {
  name: 'ImgModalMixin',

  components: {
    ImgModal,
  },

  data: () => {
    return {
      srcModalImg: '',
    };
  },

  methods: {
    showModalImg(e) {
      this.srcModalImg = e.target.src;
      this.$refs.ImgModal.show();
    },
  },
};

// GetQaQuestionMixin, BusStateMixin, ClassRestrictionMixin, TimetagInHtmlMixin
const QaTimetagMixin = {
  name: 'QaTimetagMixin',

  data: () => {
    return {
      $eventClickTimeTagIfIsLogin: null,
    };
  },

  computed: {
    ...mapState('QA/Question', {
      ms_qaQuestion: 'qaQuestion',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isLogin() {
      return Boolean(this.mg_userInfo.studentId);
    },

    c_videoInfo() {
      return this.ms_qaQuestion.videoInfo ? this.ms_qaQuestion.videoInfo : {};
    },

    c_isHaveVideoInfo() {
      return !_.isEmpty(this.c_videoInfo);
    },

    ///
    c_restrictStudent() {
      if (this.c_isHaveVideoInfo) {
        return this.c_videoInfo.restrictStudent;
      } else {
        return false;
      }
    },

    ///
    c_courseId() {
      if (this.c_isHaveVideoInfo) {
        return this.c_videoInfo.courseId;
      } else {
        return -1;
      }
    },
  },

  methods: {
    ///
    setPromiseGetClassRestriction() {
      this.promiseClassRestrictionCoursePageInfo = this.promiseGetQaQuestion;
    },

    ///
    setCurrentVideo(qaQuestion) {
      this.currentVideo = { ...qaQuestion.videoInfo };
    },

    clickTimeTagIfIsLogin($event) {
      if (this.c_isLogin) {
        this.clickTimeTag(this.ms_qaQuestion, $event);
      } else {
        this.$eventClickTimeTagIfIsLogin = $event;
        this.busState = 'busClickTimeTagIfIsLogin';
        $('#pz-login-modal').modal('show');
      }
    },

    async busClickTimeTagIfIsLogin() {
      await this.$nextTick();
      if ('busClickTimeTagIfIsLogin' === this.busState) {
        await this.promiseGetQaQuestion;
        this.clickTimeTagIfIsLogin(this.$eventClickTimeTagIfIsLogin);
        this.busState = '';
      }
    },
  },

  created() {
    this.$bus.once('login-modal-closed', this.busClickTimeTagIfIsLogin);
  },

  beforeDestroy() {
    this.$bus.off('login-modal-closed', this.busClickTimeTagIfIsLogin);
  },
};

// GetQaQuestionMixin, BusStateMixin, ClassRestrictionMixin, TimetagInHtmlMixin
const QuestionClickQaContentMixin = {
  name: 'QuestionClickQaContentMixin',

  mixins: [ImgModalMixin, QaTimetagMixin],

  methods: {
    _clickQaContent(isDoTimetagClick, $event) {
      if ('IMG' === $event.target.tagName) {
        this.showModalImg($event);
      } else if (isDoTimetagClick) {
        if (this.detectTimetag($event)) {
          this.clickTimeTagIfIsLogin($event);
        }
      }
    },

    clickQaQuestion($event) {
      this._clickQaContent(true, $event);
    },

    clickQaAnswer($event) {
      this._clickQaContent(false, $event);
    },
  },
};

const QuestionSharedNoteMixin = {
  name: 'QuestionSharedNoteMixin',

  computed: {
    ...mapState('QA/Question', {
      ms_questionSharedNote: 'questionSharedNote',
    }),
  },

  methods: {
    ...mapActions('QA/Question', {
      ma_getQuestionSharedNoteInQuestion: 'getQuestionSharedNoteInQuestion',
    }),

    getQuestionSharedNoteInQuestion() {
      this.ma_getQuestionSharedNoteInQuestion(this.$route.params.id);
    },
  },

  created() {
    this.getQuestionSharedNoteInQuestion();
  },
};

const ScrollMixin = {
  name: 'ScrollMixin',

  data: () => {
    return {
      isScrollOpen: false,
    };
  },

  methods: {
    setIsScrollOpen() {
      this.isScrollOpen = this.$refs.main.scrollTop > 150;
    },
  },

  mounted() {
    window.addEventListener('scroll', this.setIsScrollOpen, true);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.setIsScrollOpen, true);
  },
};

export default {
  name: 'QaQuestion',

  mixins: [
    GetQaQuestionMixin,
    QuestionCommentCountdownMixin,
    BusStateMixin,
    QaAnswerMixin,
    GradeMixin,
    SetUnreadMixin,
    QuestionMixin,
    OpenQuestionMixin,
    ClassRestrictionMixin,
    TimetagInHtmlMixin,
    QuestionClickQaContentMixin,
    QuestionSharedNoteMixin,
    ScrollMixin,
  ],

  components: {
    //SharedHeader,
    Footer,
    WayFindBar,
    Aside,
    //TabBar,
    Spinner,
    PzButton,
    FollowBtn,
    QaQuestionContentQuestion,
    QaQuestionContentTeacherAnswer,
    QaQuestionContentAnswer,
    QuestionReferralList,
  },

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapState('QA/Question', {
      ms_qaQuestion: 'qaQuestion',
      ms_isRequest: 'isRequest',
    }),
  },

  methods: {
    goBack() {
      const route_from = window.sessionStorage.getItem('route_from');
      if (route_from && '/' !== route_from) {
        this.$router.push(route_from);
      } else {
        this.$router.push(QA_QUESTION_LIST_PAGE).catch(() => null);
      }
    },
  },
};
